import AbstractNode from './AbstractNode';
import {replaceAndSelectNode} from "../helper/nodeSelection";

export default class ContainerPlantuml extends AbstractNode {
    get name() {
        return "code_container_plantuml";
    }

    get schema() {
        return {
            content: "text*",
            group: "block",
            code: true,
            defining: true,
            attrs: {params: {default: ""}},
            parseDOM: [{
                tag: 'div.plantuml'
            }],
            toDOM: () => ["div", {
                class: 'plantuml'
            }, 0]
        }
    }

    toMarkdown(state, node) {
        state.write(":::plantuml");
        state.ensureNewLine();
        state.text(node.textContent, false);
        state.ensureNewLine();
        state.write(":::");
        state.closeBlock(node);
    }

    get parseMarkdown() {
        return {
            block: "code_container_plantuml",
            noCloseToken: true
        }
    }

    commands({schema}) {
        return {
            createPlantUml: () => view => replaceAndSelectNode(view, schema.nodes.code_container_plantuml.create())
        }
    }
}